import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="68" height="68" viewBox="0 0 68 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g>
      <rect fill="#D9D9D9" rx="1" height="68" width="16" y="0.45873" x="0" />
      <rect fill="#D9D9D9" rx="1" height="68" width="16" y="0.45873" x="18" />
      <rect fill="#D9D9D9" rx="1" height="68" width="32" y="0.45873" x="36" />
    </g>
  </svg>
);

export default Icon;
